'use strict';

var ROMSummaryRomTimeBucketFilterFactory = function ROMSummaryRomTimeBucketFilterFactory(DataFilter) {
  function ROMSummaryRomTimeBucketFilter() {
    DataFilter.call(this, 'rom-summary-mode', 'romTimeBucket', 0);
  }
  ROMSummaryRomTimeBucketFilter.prototype = Object.create(DataFilter.prototype);
  ROMSummaryRomTimeBucketFilter.prototype.groupBy = 'romTimeBucket';
  return ROMSummaryRomTimeBucketFilter;
};
ROMSummaryRomTimeBucketFilterFactory.$inject = ['DataFilterFactory'];
module.exports = ROMSummaryRomTimeBucketFilterFactory;